module.exports = __webpack_public_path__ + "img/all-dark.49942bcf.svg";